module.exports = {
  type: 'stl',
  id: 'part',
  icon: 'table',
  title: 'ProjectDetails.construction',

  //requires: 1,
};
